import PropTypes from 'prop-types';
import React from 'react';
import SlidingPane from "react-sliding-pane";
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';
import { Widget } from '@typeform/embed-react'
import userSession from "../../../../utils/userSession";

const SurveySidePane = ({ isPaneOpen, onRequestClose, typeformID }) => {
  const breakpoint = useBreakpoint();
  const userId = userSession('id');

  return (
    <div>
      <SlidingPane
        hideHeader
        isOpen={isPaneOpen}
        width={breakpoint !== 'xs' ? '375px' : '100%'}
        shouldCloseOnEsc
        onRequestClose={onRequestClose}
        from={document.body.dir === 'ltr' ? 'right' : 'left'}
      >
        <Widget id={typeformID} hidden={{ userid: localStorage.getItem('simulatedUser') || userId }} />
      </SlidingPane>
    </div>
  )
}

SurveySidePane.propTypes = {
  isPaneOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  typeformID: PropTypes.string.isRequired,
};

SurveySidePane.defaultProps = {
  isPaneOpen: false,
};

export default SurveySidePane;
